import Vue from 'vue'
import VueRouter from 'vue-router'
import acceptLogin from '../common/middleware/acceptLogin'
import auth from '../common/middleware/auth'
import blocked from '../common/middleware/blocked'
import guest from '../common/middleware/guest'
import notBlocked from '../common/middleware/notBlocked'
import router from '../common/router/router'
import Blocked from '../views/Blocked.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LoginLayout from '@/layouts/LoginLayout'
import RestTimeApplication from '../views/RestTimeApplication'
import Widget from '../modules/sign_widget/views/Widget'
import ErrorPage from '../common/components/ErrorPage'
import SignWidgetButtons from '../modules/sign_widget/components/SignWidgetButtons'
import WidgetLayout from '../modules/sign_widget/layouts/WidgetLayout'
import SuccessPage from '../common/components/SuccessPage'
import ApplicationList from '@/common/components/application/ApplicationList.vue'
import VisitorList from '../common/components/visitor/VisitorList.vue'
import SignWidget from '../modules/sign_widget/components/sign-widget/SignWidget'
import WidgetButtonsEnum from '../modules/sign_widget/enums/WidgetButtonsEnum'
import widgetAuth from '../modules/sign_widget/middleware/widgetAuth'
import IssuedPassList from '@/common/components/IssuedPass/IssuedPassList.vue'

Vue.use(VueRouter)

export default router([
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/application/list',
    name: 'ApplicationList',
    component: ApplicationList,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/#new',
    name: 'New',
    component: Home,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/issued-passes',
    name: 'IssuedPassList',
    component: IssuedPassList,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/visitor/list',
    name: 'VisitorList',
    component: VisitorList,
    meta: {
      middleware: [
        auth,
        notBlocked
      ]
    }
  },
  {
    path: '/rest-time-application',
    name: 'RestTimeApplication',
    component: RestTimeApplication
  },
  {
    path: '/blocked',
    name: 'Blocked',
    component: Blocked,
    meta: {
      middleware: [
        auth,
        blocked
      ]
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      middleware: [
        guest
      ],
      layout: LoginLayout
    }
  },
  {
    path: '/login/accept',
    name: 'AcceptLogin',
    meta: {
      middleware: [
        guest,
        acceptLogin
      ]
    }
  },
  {
    path: '/sign',
    name: 'Widget',
    component: Widget,
    children: [
      {
        path: 'error',
        name: 'ErrorWidget',
        components: {
          content: ErrorPage,
          buttons: SignWidgetButtons
        },
        meta: {
          layout: WidgetLayout
        }
      },
      {
        path: 'success',
        name: 'SuccessWidget',
        components: {
          content: SuccessPage,
          buttons: SignWidgetButtons
        },
        props: {
          content: () => ({ message: 'Заявка подписана' })
        },
        meta: {
          layout: WidgetLayout
        }
      },
      {
        path: 'widget',
        name: 'SignWidget',
        components: {
          content: SignWidget,
          buttons: SignWidgetButtons
        },
        props: {
          content: () => ({ successRoute: '/sign/success', unsuccessRoute: '/sign/error?cause=wrongToken' }),
          buttons: () => ({ buttons: [WidgetButtonsEnum.signAndSend] })
        },
        meta: {
          middleware: [
            widgetAuth,
            notBlocked
          ],
          widget: {
            failureRedirect: '/sign/error?cause=wrongToken'
          },
          layout: WidgetLayout
        }
      }
    ]
  }
])
